<div class="d-flex flex-column">
  <div class="field-container">
    <h3> {{'createProposal.dataUploadSummary'|translate}}</h3>
  </div>
  <div
    *ngIf="(riskDescriptionUploadStatus$ | async).length === 0 && (riskLocationUploadStatus$ | async).length === 0 && (previousDamageUploadStatus$ | async).length === 0 && (proposalInformationUploadStatus$ | async).length === 0 && (individualClausesConditionsUploadStatus$ | async).length === 0">
    <h5>
      {{'createProposal.noUpload' | translate}}
    </h5>
  </div>

  <div *ngIf="(riskDescriptionUploadStatus$ | async).length > 0">
    <h5>
      {{'createProposal.riskDescriptionQuestion' | translate}}
    </h5>
  </div>

  <div *ngFor="let fileUploadStatus of riskDescriptionUploadStatus$ | async; let i = index">
    <app-upload-container [fileUploadStatus]="fileUploadStatus"></app-upload-container>
  </div>

  <div *ngIf="(riskLocationUploadStatus$ | async).length > 0">
    <h5>
      {{'createProposal.riskLocationQuestion' | translate}}
    </h5>
  </div>

  <div *ngFor="let fileUploadStatus of riskLocationUploadStatus$ | async; let i = index">
    <app-upload-container [fileUploadStatus]="fileUploadStatus"></app-upload-container>
  </div>

  <div *ngIf="(previousDamageUploadStatus$ | async).length > 0">
    <h5>
      {{'createProposal.previousDamageQuestion' | translate}}
    </h5>
  </div>

  <div *ngFor="let fileUploadStatus of previousDamageUploadStatus$ | async; let i = index">
    <app-upload-container [fileUploadStatus]="fileUploadStatus"></app-upload-container>
  </div>

  <div *ngIf="(individualClausesConditionsUploadStatus$ | async).length > 0">
    <h5>
      {{'createProposal.individualClausesConditionsQuestion' | translate}}
    </h5>
  </div>

  <div *ngFor="let fileUploadStatus of individualClausesConditionsUploadStatus$ | async; let i = index">
    <app-upload-container [fileUploadStatus]="fileUploadStatus"></app-upload-container>
  </div>

  <div *ngIf="(proposalInformationUploadStatus$ | async).length > 0">
    <h5>
      {{'createProposal.adInformation' | translate}}
    </h5>
  </div>

  <div *ngFor="let fileUploadStatus of proposalInformationUploadStatus$ | async; let i = index">
    <app-upload-container [fileUploadStatus]="fileUploadStatus"></app-upload-container>
  </div>

</div>
